(function () {
  if (typeof customElements === 'undefined' || customElements.get('cart-recommendations')) return;

  customElements.define(
    'cart-recommendations',
    class CartRecommendations extends HTMLElement {
      connectedCallback() {
        this.load(this.dataset.url + '&intent=complementary', true);
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        var btn = event.target.closest('[data-rec-add]');
        if (!btn || btn.getAttribute('aria-busy') === 'true') return;
        var label = btn.querySelector('span');
        var original = label ? label.textContent : '';
        var drawer = document.querySelector('cart-drawer');
        btn.setAttribute('aria-busy', 'true');
        if (label) label.textContent = '…';
        var body = new FormData();
        body.append('id', btn.getAttribute('data-variant-id'));
        body.append('quantity', '1');
        body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        body.append('sections_url', window.location.pathname);
        fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: body
        })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            if (state.status) throw new Error(state.description || state.message);
            drawer.renderContents(state);
          })
          .catch(function (e) {
            btn.removeAttribute('aria-busy');
            if (label) label.textContent = original;
            btn.classList.add('is-error');
            btn.title = (e && e.message) || '';
            setTimeout(function () { btn.classList.remove('is-error'); }, 2000);
          });
      }

      load(url, allowFallback) {
        fetch(url)
          .then(function (response) {
            if (!response.ok) throw new Error('recommendations ' + response.status);
            return response.text();
          })
          .then(
            function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var found = doc.querySelector('[data-cart-recs]');
              var count = found ? parseInt(found.getAttribute('data-count'), 10) : 0;
              if (count > 0) {
                this.innerHTML = found.innerHTML;
                this.hidden = false;
              } else if (allowFallback) {
                this.load(this.dataset.url + '&intent=related', false);
              }
            }.bind(this)
          )
          .catch(function () {
            /* geen aanbevelingen is geen fout: het mandje werkt gewoon door */
          });
      }
    }
  );
})();
